import { Component, OnInit, Input, Output , OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
    selector: 'sst-graph-methods',
    templateUrl: './sst-graph-methods.component.html',
    styleUrls:['./sst-graph-methods.component.css']
})

export class SSTGraphMethodsComponent implements OnInit, OnChanges {
    private rdTitleName:string;
    @Input() methodOfOperation: any;
    @Input() xAxisDataValue: any;
    @Input() graphGenerated: boolean = false;
    @Input() canGenerate: boolean = false;
    @Input() yAxisDataValue: any;
    @Input() startOver: boolean = false;
    @Input() canReset: boolean = false;
    @Input()
    set rdTitle(name:string){
     this.rdTitleName=name;
    }
    @Output() generateGraph: EventEmitter<any> = new EventEmitter();
    selectedMethodOfOperation: any;
    isMethodOfOperationSelected :boolean = false;
    isXaxisSelected: boolean = false;
    isYaxisSelected: boolean = false;
    constructor(
    ) { }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['graphGenerated']) {
            if(this.canReset){
                this.selectedMethodOfOperation = '';
                this.isMethodOfOperationSelected = false;
            }
        }
        if (changes['startOver']) {
            if(this.startOver){
                this.selectedMethodOfOperation = '';
                this.isMethodOfOperationSelected = false;
            }
        }
        if (changes['xAxisDataValue']) {
          if(this.canGenerate){
           this.isXaxisSelected = true;
          } else {
            this.isXaxisSelected = false;
          }
      }
      if (changes['yAxisDataValue']) {
        if(this.canGenerate){
         this.isYaxisSelected = true;
        } else {
          this.isYaxisSelected = false;
        }
    }
      if (changes['canGenerate']) {
        if(this.canGenerate && this.isXaxisSelected===false){
          this.isXaxisSelected = true;
        }
        if(this.canGenerate && this.isYaxisSelected===false){
          this.isYaxisSelected = true;
        }
    }
    }

    setMethodofOperation(mop) {
        if(this.canGenerate){
            this.selectedMethodOfOperation = mop;
            this.isMethodOfOperationSelected = true;
        }
    }

    graphGeneration() {
        if(this.selectedMethodOfOperation && this.canGenerate)
            this.generateGraph.emit(this.selectedMethodOfOperation);
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-methods/sst-graph-methods.component.ts